import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import styles from './styles.module.scss';

// Определяем тип сообщения по ключу
const getMessageType = (message) => {
  if (message.includes('.accept')) {
    return 'success';
  }
  if (message.includes('.finish')) {
    return 'neutral';
  }
  if (message.includes('.delete') || message.includes('.cancel') || message.includes('.reject')) {
    return 'error';
  }
  return 'default';
};

const SystemMessage = ({ message, item, user }) => {
  const { t } = useTranslation();

  const messageType = useMemo(() => getMessageType(message), [message]);
  const isActiveMessage = message === 'dialog.deal.active';

  const routeLine = useMemo(() => {
    const fromPostcode = item.loading_address?.post_code ? `, ${item.loading_address.post_code}` : '';
    const fromCity = item.loading_address?.city || item.loading_address?.state_province || item.loading_address?.country;
    const fromPart = `${item.loading_address?.country_code}${fromPostcode} ${fromCity}`;

    const toPostcode = item.unloading_address?.post_code ? `, ${item.unloading_address.post_code}` : '';
    const toCity = item.unloading_address?.city || item.unloading_address?.state_province || item.unloading_address?.country;
    const toPart = `${item.unloading_address?.country_code}${toPostcode} ${toCity}`;

    return `${fromPart} - ${toPart}`;
  }, [item.loading_address, item.unloading_address]);

  const messageText = useMemo(() => {
    if (isActiveMessage) {
      return ''; // Не показываем текст для активной сделки
    }
    const userName = user?.firstname || '';
    const actionText = t(message, { user: '', deal: '' }).replace('{{deal}}', '').trim();
    return userName ? `${userName} ${actionText}` : actionText;
  }, [message, user, t, isActiveMessage]);

  return (
    <div className={cn(
      styles.systemMessage,
      messageType === 'success' && styles['systemMessage--success'],
      messageType === 'error' && styles['systemMessage--error'],
      messageType === 'neutral' && styles['systemMessage--neutral'],
      isActiveMessage && styles['systemMessage--plain'],
    )}>
      {messageText && <div className={styles.systemMessage__text}>{messageText}</div>}
      <div className={styles.systemMessage__details}>
        <div className={styles.systemMessage__line}>{routeLine}</div>
      </div>
    </div>
  );
};

export default SystemMessage;
